export default abstract class Service {

}